export enum SystemFieldProofreadingStatus {
  NO_PROOFREADING = "no_proofreading",
  NEEDS_WORK = "needs_work",
  PROOFREAD_ONCE = "proofread_once",
  PROOFREAD_TWICE = "proofread_twice",
  APPROVED = "approved",
}
export enum SystemEntityProofreadingStatus {
  NOT_PROOFREAD = "not_proofread",
  PARTLY_PROOFREAD = "partly_proofread",
  UNPUBLISHED = "unpublished",
  PUBLISHED = "published",
}

export enum SystemEntityCollections {
  TEXT = "Texts",
  VERSION = "Versions",
  WORK = "Works",
  PERSON = "Persons",
  COLOPHON = "Colophons",
  BIBLIOGRAPHY = "Bibliographies",
  PLACE = "Places",
  TEAM = "Teams",
  USER_ENUM = "User_enums",
  CONTRIBUTOR = "Contributor_of_version",
  ANCILLARY = "Work_ancillary_to",
  REFERENCE_VERSION = "Referring_to",
  PERSON_CONNECTION = "Person_connection",
  PLACE_OF_PERSON = "Place_of_person",
  VERSION_TEAM = "Version_team",
  TEAM_MEMBER = "Team_member",
}
export enum SystemLanguages {
  tibetan = "tibetan",
  indic = "indic",
  chinese = "chinese",
}

export const SYSTEM_LANGUAGE_LABELS: Record<SystemLanguages, string> = {
  tibetan: "Tibetan",
  indic: "Indic",
  chinese: "Chinese",
};
